import Purchase from '@/screens/purchaseOrders'
import PurchaseOrdersCreate from '@/screens/purchaseOrders/Create'
import Invoices from '@/screens/purchaseOrders/Invoices'
import PurchaseOrders from '@/screens/purchaseOrders/List'
import IntelligentPurchase from '@/screens/purchaseOrders/IntelligentPurchase'
import PurchaseOrdersShoppingList from '@/screens/purchaseOrders/ShoppingList'
import Balance from '@/screens/balance/Balance'
import CommissionOrders from '@/screens/purchaseOrders/Commissions'
import Purchases from '@/screens/finances/Purchases'

import auth from './middleware/auth'

import store from '@/store'

const routes = [
  {
    path: '/purchase',
    name: 'Purchase',
    component: {
      ...Purchase,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Purchase') {
          const routes = {
            manager: 'PurchaseOrdersCreate',
            stockmanager: 'PurchaseOrders',
            buyer: 'PurchaseOrdersCreate'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Purchase') {
          const routes = {
            manager: 'PurchaseOrdersCreate',
            stockmanager: 'PurchaseOrders',
            buyer: 'PurchaseOrdersCreate'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'purchase-orders-create',
        name: 'PurchaseOrdersCreate',
        component: PurchaseOrdersCreate,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      },
      {
        path: 'purchase-orders/:id?',
        name: 'PurchaseOrders',
        component: PurchaseOrders,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'provider', 'provider-buyer', 'stockmanager', 'buyer'],
          middleware: { auth }
        }
      },
      {
        path: 'intelligent-purchase/:id?',
        name: 'IntelligentPurchase',
        component: IntelligentPurchase,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'stockmanager', 'buyer'],
          middleware: { auth }
        }
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: Invoices,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      }
    ]
  },
  {
    path: '/balance',
    component: Balance,
    name: 'Balance',
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/purchase-orders-products',
    name: 'PurchaseOrdersShoppingList',
    component: PurchaseOrdersShoppingList,
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    name: 'CommissionOrders',
    component: CommissionOrders,
    path: '/commission-orders',
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    name: 'PurchasesMade',
    component: Purchases,
    path: '/purchase-made',
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  }
]

export default routes
